'use client'


import { bannerTypes } from "@/context/bannerContext";
import { useNav } from "@/context/navContext";
import { mediaUrl } from "@/util/util";
import React from "react";

export interface BannerProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  bannerMap?: bannerTypes;
}

const PageBanner = React.forwardRef<HTMLImageElement, BannerProps>(
  ({ bannerMap, className = "", ...rest }, ref) => {
    const {movePage} = useNav()

    const imageUrl = bannerMap?.image_url ?? "";
    const redirectUrl = bannerMap?.redirect_url ?? "#";

    return (
      <div className="page-banner">
          <a onClick={e=> movePage(redirectUrl)} className="--pointer">
              <img ref={ref}
                  src={mediaUrl(imageUrl)}
                  style={{ display: imageUrl ? "block" : "none" }}
                  {...rest} />
          </a>
      </div>
    );
  }
);

export default PageBanner;
